import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang, UI } from "@/lib/lang";

export default function IntroLoader({ logo, name }) {
  const { t } = useLang();
  const [visible, setVisible] = useState(true);
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let p = 0;
    const step = () => {
      p += Math.random() * 12 + 6;
      if (p >= 100) {
        setPct(100);
        setTimeout(() => setVisible(false), 550);
      } else {
        setPct(Math.round(p));
        setTimeout(step, 120);
      }
    };
    step();
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          exit={{ y: "-100%" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[100] bg-[#0A0A0A] flex flex-col items-center justify-center"
          data-testid="intro-loader"
        >
          <motion.img
            src={logo}
            alt={name}
            initial={{ opacity: 0, scale: 0.85, filter: "blur(20px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            className="w-48 md:w-64 h-auto drop-shadow-[0_20px_60px_rgba(30,127,255,0.4)]"
          />
          <div className="mt-12 w-64 md:w-96">
            <div className="flex justify-between num-tick mb-2">
              <span>{t(UI.loading)} · {name?.toUpperCase()}</span>
              <span>{String(pct).padStart(3, "0")}%</span>
            </div>
            <div className="h-px w-full bg-white/10 overflow-hidden">
              <motion.div
                className="h-full bg-[#1E7FFF]"
                animate={{ width: `${pct}%` }}
                transition={{ duration: 0.25 }}
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
